import script from "./InternalDeliveryManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalDeliveryManagement.vue?vue&type=script&setup=true&lang=js"

import "./InternalDeliveryManagement.vue?vue&type=style&index=0&id=587567b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587567b6"]])

export default __exports__